import ActivixDate from '@/value-objects/ActivixDate.js';
import LeadType from '@/entities/LeadType.js';
import CreatedMethod from '@/entities/CreatedMethod.js';
import CommunicationMethod from '@/entities/CommunicationMethod.js';
import CommunicationType from '@/entities/CommunicationType.js';

export function isLeadGuest(user, lead, contextAccount) {
    if (!user) {
        return true;
    }

    if (user.isAdmin()) {
        return false;
    }

    if (!user.hasAccessToEditAccount(lead.account_id)) {
        return true;
    }

    const releaseDate = new ActivixDate('2021-05-01 00:00');
    const leadCreationDate = new ActivixDate(lead.created_at);

    if (lead.lead_type_id === LeadType.EVENT && leadCreationDate.isAfter(releaseDate)) {
        const associatedLeads = Array.isArray(lead.associated_leads)
            ? lead.associated_leads
            : lead.customer?.leads || [];
        const hasRelatedLead = associatedLeads.some((associatedLead) => {
            const associatedLeadId =
                associatedLead && typeof associatedLead === 'object'
                    ? associatedLead.id
                    : associatedLead;

            return String(associatedLeadId) === String(lead.event_related_id);
        });

        if (!lead.event_related_id || !hasRelatedLead) {
            return true;
        }
    }

    if (lead.isAssignedTo(user.id)) {
        return false;
    }

    if (
        !user.isDirector() &&
        lead.lead_type_id == LeadType.EMAIL &&
        lead.created_method != CreatedMethod.MANUAL &&
        lead.account.leadxpress &&
        lead.leadxpress_flow &&
        lead.account.leadxpress_option.priority &&
        !userHasAccessToLeadXpressFlow(lead, user.id, contextAccount ?? lead.account)
    ) {
        return true;
    }

    return false;
}

function userHasAccessToLeadXpressFlow(lead, userId, contextAccount) {
    const defaultFlowDivision = contextAccount.leadxpress_option?.division || null;
    const validFlow = contextAccount.flows.find((flow) => {
        return (
            !flow.round_robin &&
            ((lead.division_id && flow.division_id == lead.division_id) ||
                (!lead.division_id && flow.division_id == defaultFlowDivision) ||
                (!lead.division_id &&
                    !flow.division_id &&
                    flow.lead_form_id &&
                    lead.lead_form_id &&
                    flow.lead_form_id == lead.lead_form_id)) &&
            flow.communication_method_id == CommunicationMethod.EMAIL &&
            flow.communication_type_id == CommunicationType.INCOMING
        );
    });

    if (!validFlow) {
        return true;
    }

    const userIsInFlow = validFlow.activeUsers.some((flowUser) => {
        return userId == flowUser.id && flowUser.flow_order;
    });
    const userIsInFutureProcedure = validFlow.activeUsers.some((flowUser) => {
        return userId == flowUser.id && Math.floor(flowUser.flow_order) > lead.leadxpress_flow;
    });

    if (!userIsInFlow) {
        return false;
    }

    if (fallbackEnoughTimeElapsed(lead)) {
        return true;
    }

    return !userIsInFutureProcedure;
}

function fallbackEnoughTimeElapsed(lead) {
    const minutesSinceLeadCreation = new ActivixDate('now').diffInMinutes(
        new ActivixDate(lead.created_at)
    );
    return minutesSinceLeadCreation >= lead.account.leadxpress_option.priority * 6;
}
